
























































import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types/index";
import { SortWarekiDate } from "#/utility/appSort";
import { toWarekiDatetime } from "#/utility/appDate";
import BaseReportList from "@/components/patient/BaseReportList.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { Record3ListItem } from "@/components/list/baseRecord3List";

interface SubmitRecord3ListItem extends Record3ListItem {
  patient_name: string;
}

interface FormattedRecord extends SubmitRecord3ListItem {
  status: number;
  created_at_wareki: string;
}

interface SearchParams {
  part: {
    office_ids: number[];
    group_ids: number[];
    group_operator: number;
    keyword: string;
  };
  start_month: string;
  end_month: string;
}

@Component({
  components: {
    BaseReportList
  }
})
export default class SubmitRecord3List extends Mixins(AxiosMixin, UtilMixin) {
  @Ref("reportList") private readonly reportList?: BaseReportList;

  /** 絞り込み済みフラグ（AppFilterButton の強調表示用） */
  @Prop({ default: false }) isFiltered!: boolean;

  /** COMMON.REPORT_STATUS.SUBMIT */
  private readonly REPORT_SUBMIT = 2;

  private records: FormattedRecord[] = [];
  private currentParams: SearchParams | null = null;

  /** トップスロットのキーワード検索条件 */
  private searchCond = { keyword: "" };

  private headers: DataTableHeader[] = [
    {
      text: "利用者",
      value: "patient_name",
      width: "170px"
    },
    {
      text: "訪問日",
      value: "target_date_wareki",
      width: "150px",
      sort: SortWarekiDate
    },
    {
      text: "レセプト事前チェック処理日",
      value: "created_at_wareki",
      width: "500px",
      sort: SortWarekiDate
    }
  ];

  /** 親から検索条件を受け取り、一覧をリセットして再取得する */
  public search(params: SearchParams): void {
    this.currentParams = params;
    this.searchCond.keyword = params.part.keyword;
    this.reportList?.resetLoaded();
  }

  /** トップスロットの検索ボタン押下 */
  private clickSearch(): void {
    this.$emit("click-search", this.searchCond.keyword);
  }

  /** BaseReportList からのデータ更新イベント */
  private onUpdateData({ page }: { tab: number; page: number }): void {
    if (!this.currentParams) return;
    this.fetchRecords(page);
  }

  private pdfRecord3(item: SubmitRecord3ListItem): void {
    this.makePdf(window.base_url + "/api/patient/visitrecord3/preview", {
      id: item.id
    });
  }

  private fetchRecords(page: number): void {
    if (!this.currentParams) return;
    this.postJsonCheck(
      window.base_url + "/api/patient/visitrecord3s/search",
      {
        ...this.currentParams,
        page: page + 1,
        limit: 20
      },
      res => {
        const fetched: FormattedRecord[] = (res.data.records ?? []).map(
          (r: SubmitRecord3ListItem) => ({
            ...r,
            status: this.REPORT_SUBMIT,
            created_at_wareki: toWarekiDatetime(r.created_at, true, true)
          })
        );
        if (page === 0) {
          this.records = fetched;
        } else {
          this.records = [...this.records, ...fetched];
        }
        this.$emit(
          "update:medical-comprehensive-flg",
          res.data.medical_comprehensive_flg ?? 0
        );
        this.reportList?.finishLoaded(fetched);
      }
    );
  }
}
